import * as propertyTypes from "../../property_types.js"
import { DataIsTemplateStringProperty, RightDrawerContainer, DataMenu, DataGridOptions } from "./common_app_metadata.js";

export class AppPart extends propertyTypes.Serializable {
    private additionalMetadata = new propertyTypes.ObjectPropertyExt("additional", "Additional")
        .addStateImplementation("default", Additional);
    public additional: Additional;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata.RenderInline = true;
        this.metadataAll = [this.additionalMetadata];
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }

}

class Additional extends propertyTypes.Serializable {

    private objectsMetadata = new propertyTypes.ObjectListPropertyExt("objects", "Additional objects", "name")
        .addStateImplementation("browserTitle", DataIsTemplateStringProperty)
        .addStateImplementation("pageTitle", DataIsTemplateStringProperty)
        .addStateImplementation("translations", DataTranslations)
        .addStateImplementation("rightDrawerContainer", RightDrawerContainer)
        .addStateImplementation("menuDataSource", DataMenu)
        .addStateImplementation("csGridOptions", DataGridOptions)
        ;
    public objects: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.objectsMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.objectsMetadata];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class DataTranslations extends propertyTypes.Serializable {
    private nameMetadata = new propertyTypes.TextProperty("name", "Name");
    public name: string;

    private dataMetadata = new propertyTypes.ObjectPropertyExt("data", "Data")
        .addStateImplementation("default", MachineAppTranslations);
    public data: MachineAppTranslations;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.nameMetadata.IsReadOnly = true;
        this.additionalMetadata = [this.nameMetadata, this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}

class MachineAppTranslations extends propertyTypes.Serializable {
    private Standard_Msg_LoeschenMetadata = new propertyTypes.TranslatableTextProperty("Standard.Msg.Loeschen", "Standard.Msg.Loeschen");
    private Standard_Neu = new propertyTypes.TranslatableTextProperty("Standard.Neu", "Standard.Neu");
    private Standard_Editieren = new propertyTypes.TranslatableTextProperty("Standard.Editieren", "Standard.Editieren");
    private Standard_Loeschen = new propertyTypes.TranslatableTextProperty("Standard.Loeschen", "Standard.Loeschen");
    private MonitorBaum_NeuLaden = new propertyTypes.TranslatableTextProperty("MonitorBaum.NeuLaden", "MonitorBaum.NeuLaden");
    private WebCRM_Email_Send = new propertyTypes.TranslatableTextProperty("WebCRM.Email.Send", "WebCRM.Email.Send");
    private Parts_ChargenSerien_InvalidAmount = new propertyTypes.TranslatableTextProperty("Parts.ChargenSerien.InvalidAmount", "Parts.ChargenSerien.InvalidAmount");
    private Field_Parts_ArticleEditing = new propertyTypes.TranslatableTextProperty("Field.Parts.ArticleEditing", "Field.Parts.ArticleEditing");

    private allTranslationsMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.allTranslationsMetadata = [this.Standard_Msg_LoeschenMetadata, this.Standard_Neu, this.Standard_Editieren, this.Standard_Loeschen, this.MonitorBaum_NeuLaden, this.WebCRM_Email_Send,
        this.Parts_ChargenSerien_InvalidAmount, this.Field_Parts_ArticleEditing
        ];
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.allTranslationsMetadata;
    }
}

class DataOpeningHoursSchema extends propertyTypes.Serializable {
    private dataMetadata = new propertyTypes.NotEditableProperty("data", "Data");
    public data: string;

    private additionalMetadata: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.additionalMetadata = [this.dataMetadata];
        //this.dataMetadata.RenderInline = true;
    }

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.additionalMetadata;
    }
}